import { Context, Plugin } from '@nuxt/types';
import { Store } from 'vuex';
// @ts-ignore
import VueI18n from 'vue-i18n';

export interface Notify {
  push(payload: any): Promise<any>;

  success(payload: any): Promise<any>;

  error(payload: any): Promise<any>;

  pending(payload: any): Promise<any>;

  warning(payload: any): Promise<any>;

  remove(payload: any): Promise<any>;

  unknownError(): Promise<any>;

  all: any;
}

declare module 'vue/types/vue' {
  interface Vue {
    $notify: Notify;
  }
}
declare module '@nuxt/types' {
  interface NuxtAppOptions {
    $notify: Notify;
  }

  interface Context {
    $notify: Notify;
  }
}

const getNotify = (store: Store<any>, i18n: VueI18n) => ({
  push: (payload: any) => store.dispatch('notification/push', payload),
  success: (payload: any) => store.dispatch('notification/pushSuccess', payload),
  error: (payload: any) => store.dispatch('notification/pushError', payload),
  pending: (payload: any) => store.dispatch('notification/pushPending', payload),
  warning: (payload: any) => store.dispatch('notification/pushWarning', payload),
  remove: (payload: any) => store.dispatch('notification/remove', payload),
  unknownError: () =>
    store.dispatch(
      'notification/pushError',
      i18n.t(
        'An unknown error occurred. Please try again later. If the issue persists, please contact us.'
      )
    ),
  all: store.getters['notification/all'],
});

const notifyPlugin: Plugin = ({ store, app }: Context, inject) => {
  inject('notify', getNotify(store, app.i18n));
};

export default notifyPlugin;
